module.exports = __webpack_public_path__ + "static/media/md-pause.ef275f0a.svg";